import React, { Component } from "react";
import { Link } from "react-router-dom";
import $ from "jquery/dist/jquery.js";

import * as apiConstant from "../../../api/apiConstant";
import { Businesses } from "../../../config/Helper";
import { lang } from "../../../config/lang";
import { getVideoThumbFileName } from "../../../config/utils";
import * as UTILS from "../../../config/utils";
import { setTimeout } from "timers";
import logApi from "../../../api/logApi";
/****************************************
    Component for News Block on Home Page
    @author  IMH003
    @date    2020.05.22
    @version 0.1    
 ******************************************/
class NewsBlock extends Component {
  constructor(props) {
    super(props);
    this.business = this.props.business;
    this.id = this.props.id;

    this.waitAndEllipsis = this.waitAndEllipsis.bind(this);
    this.ellipsisStyle = this.ellipsisStyle.bind(this);
    this.onErrorImageLoad = this.onErrorImageLoad.bind(this);
  }

  componentWillMount() {}

  componentDidMount() {
    if (this.props.media_type === 0) {
      window.checkSize();
    }

    window.addEventListener("resize", this.waitAndEllipsis);

    // setTimeout(this.ellipsisStyle, 400);
  }

  componentDidUpdate() {
    setTimeout(this.ellipsisStyle, 400);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.waitAndEllipsis);
  }

  componentWillReceiveProps(newProps) {}

  waitAndEllipsis() {
    setTimeout(this.ellipsisStyle, 800);
  }

  ellipsisStyle() {
    window.ellipsisMe("#title_" + this.props.business + "_" + this.props.id);
    window.ellipsisMe("#desc_" + this.props.business + "_" + this.props.id);
  }

  onErrorImageLoad() {
    $("#img_" + this.props.business + "_" + this.props.id).attr(
      "src",
      "/assets/images/no_image.png"
    );
  }

  render() {
    return (
      <div className="single-post-area wow fadeInUp" data-wow-delay="300ms">
        <div>
          <Link
            to={`/blog/${Businesses[this.props.business]}/${this.props.id}`}
            className="post-thumbnail"
          >
            {(this.props.image === undefined || this.props.image === null) && (
              <img src="/assets/images/no_image.png" alt="new-block-no" />
            )}
            {this.props.media_type === 0 && (
              <img
                id={`img_${this.props.business}_${this.props.id}`}
                onError={() => this.onErrorImageLoad()}
                src=""
                data-desktop-image={apiConstant.thumbnail(
                  this.props.business,
                  this.props.id,
                  this.props.image
                )}
                data-tablet-image={apiConstant.tablet(
                  this.props.business,
                  this.props.id,
                  this.props.image
                )}
                data-mobile-image={apiConstant.mobile(
                  this.props.business,
                  this.props.id,
                  this.props.image
                )}
                alt="new-block-photo"
              />
            )}
            {this.props.media_type === 1 && (
              <div>
                <img
                  id={`img_${this.props.business}_${this.props.id}`}
                  onError={() => this.onErrorImageLoad()}
                  src={apiConstant.thumbnail(
                    this.props.business,
                    this.props.id,
                    getVideoThumbFileName(this.props.image)
                  )}
                  alt="new-block-video"
                />
              </div>
            )}
          </Link>
          {this.props.media_type === 1 && (
            <a
              href={apiConstant.desktop(
                this.props.business,
                this.props.id,
                this.props.image
              )}
              className="play-video video-icon"
              onClick={() =>
                logApi.log({
                  title: this.props.title,
                  lang: localStorage.getItem("language"),
                  type: "동화상",
                })
              }
            >
              <i className="fa fa-play" aria-hidden="true"></i>
            </a>
          )}
        </div>

        <div className="post-meta">
          <div className="star d-flex-flex clearfix">
            <div className="mr-auto float-left">
              <span
                className="post-date"
                style={{
                  marginLeft:
                    localStorage.getItem("language") === "cn"
                      ? "21.25pt"
                      : "14.5pt",
                }}
              >
                {UTILS.getDateString(this.props.created_at)}
              </span>
            </div>
            {this.props.isNew === 1 && (
              <div className="float-right">
                <span className="rate">{lang("new")}</span>
              </div>
            )}
          </div>
        </div>

        <Link to={`/blog/${Businesses[this.props.business]}/${this.props.id}`}>
          <div
            className="post-title ellipsis"
            id={`title_${this.props.business}_${this.props.id}`}
            style={{
              textIndent:
                localStorage.getItem("language") === "cn"
                  ? "21.25pt"
                  : "14.5pt",
            }}
            caption={this.props.title}
            dangerouslySetInnerHTML={{ __html: this.props.title }}
          />
        </Link>
        {/* <p className="post-description ellipsis multiline" 
                    id={`desc_${this.props.business}_${this.props.id}`}
                    caption = {UTILS.symbolingText(this.props.description)}
                    dangerouslySetInnerHTML={{__html: UTILS.symbolingText(this.props.description)}} /> */}
        <Link
          to={`/blog/${Businesses[this.props.business]}/${this.props.id}`}
          className="btn continue-btn"
        >
          <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
        </Link>
      </div>
    );
  }
}

export default NewsBlock;
